import { Button, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Info, Trash2 } from 'react-feather'
import {
    CustomTableData,
    CustomDropDown,
    TooltipInformation,
    TooltipApprovalInfo
} from '../../../../../../../common'


export const TransactionTable = ({ useFetchInit }) => {

    const {
        globalStates,
        // FetchData,
        Actions,
        Forms
    } = useFetchInit

    const { formOpeningMode } = globalStates

    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal

    // const { fetchTransactionsByPayment } = FetchData
    // const { loadingFetchTransactionsByPayment } = fetchTransactionsByPayment

    const {
        handleClickFetchSpecificRetroTransaction,
        handleClickTransactionForRetroactive,
        handleClickDeleteItemFromTable
    } = Actions

    const isReadOnly = (formOpeningMode==='READONLY')

    const columnConfig = [
        {
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { iddeposit, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        idregistro={iddeposit}
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        {
            field: "deposito_fecha",
            headerName: "FECHA",
            minWidth: 130,
            maxWidth: 130,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
        },
        { field: "movimiento_tipo", headerName: "TIPO", minWidth: 140, filter: true },
        { field: "banco", headerName: "BANCO", minWidth: 130, filter: true },
        { field: "boleta_numero", headerName: "No. BOLETA", minWidth: 140, filter: true },
        { field: "deposito_moneda", headerName: "MONEDA", minWidth: 130, filter: true },
        { field: "deposito_tipo_cambio", headerName: "CAMBIO", minWidth: 130, filter: true },
        { field: "deposito_quetzal", headerName: "TOTAL (Q)", minWidth: 130, filter: true },
        { field: "deposito_dolares", headerName: "TOTAL ($)", minWidth: 130, filter: true },
        {
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 200,
            maxWidth: 200,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {

                if (params.value === 'APROBADO') return 'bg-success';
                if (params.value === 'PENDIENTE') return 'bg-warning';
                if (params.value === 'RECHAZADO') return 'bg-danger';
                if (params.value === 'REVERTIDO') return 'bg-secondary text-white';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data
                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                )
            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 200,
            cellRenderer: (params) => {
                const { idmovimiento, aprobacion_check, estado } = params.data

                return (
                    <CustomDropDown color={(estado === 1) ? 'inherit' : 'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificRetroTransaction(idmovimiento)}
                        >
                            <ListItemIcon> <Info color="black" /> </ListItemIcon>
                            <ListItemText primary="Ver Detalles" />
                        </MenuItem>
                        {/* <MenuItem
                            disabled={aprobacion_check !== 'APROBADO'}
                            onClick={() => handleClickDownloadTicket(idmovimiento)}
                        >
                            <ListItemIcon> <FileText color="black" /> </ListItemIcon>
                            <ListItemText primary="Recibo" />
                        </MenuItem> */}
                        {((aprobacion_check === 'PENDIENTE') && (formOpeningMode === 'EDITABLE')) && (
                            <MenuItem
                                onClick={() => handleClickDeleteItemFromTable({
                                    itemId: 'idmovimiento',
                                    paramSearch: idmovimiento,
                                    arrayDataRowsName: 'transactions'
                                })}
                            >
                                <ListItemIcon> <Trash2 color="black" /> </ListItemIcon>
                                <ListItemText primary="Eliminar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )

            }
        },
    ]

    return (
        <>
            <div className="d-flex justify-content-end pt-4 pb-2">
                <Button
                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                    type='button'
                    variant="contained"
                    onClick={handleClickTransactionForRetroactive}
                    disabled={isReadOnly}
                >
                    <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                </Button>
            </div>
            {/* {(loadingFetchTransactionsByPayment) && (<CustomLoading/>)} */}
            <CustomTableData
                rowConfig={formState.transactions}
                // rowConfig={[]}
                columnConfig={columnConfig}
            />
        </>
    )
}